let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6mTOp")).then(() => parcelRequire('9ymKp'));